import { GameType, MenuItemType } from "../types";

const GAME_PAGES = {
  magicPen: "magicPenHome",
  talkAlongCards: "talkAlongCards",
  qaCards: "QACards",
} as const satisfies Record<string, GameType>;

const MENU_PAGES = [
  "event",
  "listen",
  "watch",
  "playing",
  "story",
  "bedtime",
] as const satisfies readonly MenuItemType[];

type DeepLink = {
  menuItem: MenuItemType;
  game: GameType | null;
};

export default function getDeepLink(): DeepLink | null {
  const page = new URLSearchParams(window.location.search).get("page");

  if (!page) return null;

  if (page in GAME_PAGES)
    return {
      menuItem: "playing",
      game: GAME_PAGES[page as keyof typeof GAME_PAGES],
    };

  if ((MENU_PAGES as readonly string[]).includes(page))
    return { menuItem: page as (typeof MENU_PAGES)[number], game: null };

  return null;
}
